import React from "react"
import { EditBandFormField, isLikelyUrl } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface MailingListProps {
  band: Band
}

export const MailingList: React.FC<MailingListProps> = ({ band }) => {
  const fieldData = {
    field: "mailing_list_url",
    name: "bandMailingListUrl",
    label: "Mailing List URL",
    placeholder: "Your Mailing List Link",
    required: false,
  }

  return (
    <EditBandFormField type="text" fieldData={fieldData} validate={isLikelyUrl} />
  )
}
